import { HeadersName } from '../datasource';

export type AuthorizationStrategyType = 'memoryCache';

export type AuthorizationStrategy = {
    provideAuthorizationHeaders: () => Promise<Partial<Record<HeadersName, string>>>;
    provideCredentials: () => { credentials: RequestCredentials } | undefined;
};

export const defaultServerAuthStrategy: Partial<AuthorizationStrategy> = {};

export const memoryCacheAuthStrategy: Partial<AuthorizationStrategy> = {};
